import { LS_KEY } from "../constants/storage.js";

function loadStarred() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    const parsed = JSON.parse(raw || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export const store = {
  transponders: [],
  programs: [],

  tpByKey: new Map(),
  programsByTpKey: new Map(),

  selection: new Map(),
  starred: new Set(loadStarred()),
  openDetails: new Set(),
  openMeta: new Set(),

  db: {
    sourceType: "",
    date: "Datum unbekannt",
    fileName: "",
    derivedDate: ""
  },

  ui: {
    lnbType: "universal",
    tab: "tp",
    favTab: "fta"
  }
};

export function saveStarred() {
  localStorage.setItem(LS_KEY, JSON.stringify([...store.starred]));
}

export function rebuildIndexes() {
  store.tpByKey = new Map();
  store.programsByTpKey = new Map();

  for (const tp of store.transponders || []) {
    if (!tp || !tp.tp_key) continue;
    store.tpByKey.set(tp.tp_key, tp);
  }

  for (const program of store.programs || []) {
    if (!program || !program.tp_key) continue;

    if (!store.programsByTpKey.has(program.tp_key)) {
      store.programsByTpKey.set(program.tp_key, []);
    }

    store.programsByTpKey.get(program.tp_key).push(program);
  }
}

export function setDatabase({
  transponders,
  programs,
  sourceType,
  date,
  fileName,
  derivedDate
}) {
  store.transponders = Array.isArray(transponders) ? transponders : [];
  store.programs = Array.isArray(programs) ? programs : [];

  store.db.sourceType = sourceType || "";
  store.db.date = date || "Datum unbekannt";
  store.db.fileName = fileName || "";
  store.db.derivedDate = derivedDate || "";

  rebuildIndexes();

  // Offene Details zurücksetzen, damit keine alten Zustände stören
  store.openDetails = new Set();
  store.openMeta = new Set();

  // Auswahl nur behalten, wenn die Transponder in der neuen DB noch existieren
  const nextSelection = new Map();
  for (const [tpKey, value] of store.selection.entries()) {
    if (store.tpByKey.has(tpKey)) {
      nextSelection.set(tpKey, value);
    }
  }
  store.selection = nextSelection;
}
